import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List } from 'immutable';

import { AppPage } from '../AppPage';
import Tabs from '../helpers/Tabs';

import style from './style.module.css';

const BrowseComponent = ({ tabs, children }) => (
  <AppPage
    overline="Browse"
    title="Companies, Executives & Projects"
    toolbar={<Tabs className={style.tabs} tabs={tabs} />}
  >
    <div className={style.host}>{children}</div>
  </AppPage>
);

BrowseComponent.propTypes = {
  tabs: PropTypes.instanceOf(List).isRequired,
};

/** Browse component. */
export const Browse = memo(BrowseComponent);
